import store from '../store'

export function checkScroll() {
  let timer = null

  function run() {
    clearTimeout(timer)
    timer = setTimeout(() => {
      store.flags.isScrolling = false
    }, 150)

    if (!store.isScrolling) {
      store.flags.isScrolling = true
    }
  }

  return { run }
}